// extracted by mini-css-extract-plugin
export default {"module-modal-content":"CreateModuleModal_module-modal-content__wSFhQ"};